<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.userInfo.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel35')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="listbox">
            <div class="listright">
                <div class="searchleft" style="margin-top:50px">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('tel36')">
                            <el-radio-group v-model="selectedValue" @change="handleRadioChange">
                                <el-radio label="1" border>{{$t('tel37')}}</el-radio>
                                <el-radio label="2" border>{{$t('tel38')}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="selectedValue == 1" :label="$t('tel39')">
                            <el-select v-model="searchform.platform" :placeholder="$t('qxz')">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="selectedValue == 2" :label="$t('tel39')">
                            <el-select v-model="searchform.platform" :placeholder="$t('qxz')">
                                <el-option
                                v-for="item in options1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('tel40')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return { 
                searchform: {
                    blurry: "",
                    channel: '1',
                    platform:null,
                },   
                options: [{
                    value: '0',
                    label: '牛信云'
                }, {
                    value: '1',
                    label: '天一泓'
                }],
                options1: [{
                    value: 'EasyLend',
                    label: 'EasyLend'
                }, {
                    value: 'FastCredit',
                    label: 'FastCredit'
                }, {
                    value: 'GreenLine',
                    label: 'GreenLine'
                },{
                    value: 'InputRapida',
                    label: 'InputRapida'
                },{
                    value: 'Mcash',
                    label: 'Mcash'
                },{
                    value: 'MSFRapida',
                    label: 'MSFRapida'
                },{
                    value: 'SuPrestamo',
                    label: 'SuPrestamo'
                },{
                    value: 'TelcopsPrestamos',
                    label: 'TelcopsPrestamos'
                }],
                value: '',
                selectedValue: '1',
            }
        },
        created() {
            this.userInfo = JSON.parse(localStorage.getItem("userinfo"))
            this.searchform.channel = 1
        },
        methods: {
            handleRadioChange(value) {
                this.searchform.platform=null;
            },
            onSubmit() {
                if (this.searchform.platform == null) {
                    alert("请选择推送平台");
                }
                _api.get(apiurl.labour, {
                    channel: this.selectedValue,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('czcg')
                    })
                });
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>